// Runtime decision: one bundle serves every site, so nothing at build time tells
// them apart. Suffix rules, not a list: *.previews.dev mints a host per open PR.
export const BOXCAST_OWNED_DOMAINS = ['boxcast.com', 'boxcast.tv', 'boxcast.github.io'];

const LOCAL_HOSTS = ['localhost', '127.0.0.1', '[::1]', ''];

export function matchOwnedDomain(hostname) {
  const host = String(hostname || '')
    .toLowerCase()
    .replace(/\.$/, ''); // a fully-qualified name may carry a trailing dot
  for (var i = 0; i < BOXCAST_OWNED_DOMAINS.length; i++) {
    const domain = BOXCAST_OWNED_DOMAINS[i];
    if (host === domain || host.endsWith('.' + domain)) {
      return domain;
    }
  }
  return null;
}

export function resolveAnalyticsPolicy(env) {
  const hostname = env.hostname || '';
  const matchedDomain = matchOwnedDomain(hostname);
  const base = { hostname: hostname, matchedDomain: matchedDomain };

  if (env.pageOptOut) {
    return { ...base, enabled: false, reason: 'page-opt-out' };
  }
  if (env.configOptOut) {
    return { ...base, enabled: false, reason: 'embed-option-opt-out' };
  }
  if (matchedDomain) {
    return { ...base, enabled: false, reason: 'boxcast-owned-domain' };
  }
  if (LOCAL_HOSTS.indexOf(String(hostname).toLowerCase()) >= 0) {
    return { ...base, enabled: false, reason: 'local-development-host' };
  }
  if (!env.isProductionBuild) {
    return { ...base, enabled: false, reason: 'non-production-build' };
  }
  return { ...base, enabled: true, reason: 'enabled-by-default' };
}

// Embed options arrive as strings: boxcast_tv's iframe pipeline coerces only
// autoplay and dvr, so ?disableAnalytics=true is the string "true". Not a bare
// truthy check, which would read the string "false" as opting out.
export function isOptedOut(value) {
  if (value === true || value === 1) {
    return true;
  }
  if (typeof value !== 'string') {
    return false;
  }
  const v = value.trim().toLowerCase();
  return v === 'true' || v === '1';
}
